import Call from '../Call';
import queryString from 'querystring'

const AdSense = {
    getToken(code) {
        const body = {
            code,
            client_id: '221994429881-fmrabivcrbptipcd8qdb7c5a7hurp0pb.apps.googleusercontent.com',
            client_secret: 'SN-pqPag5h2VZP5M0D3FSZ5c',
            redirect_uri: 'https://dash.push-signals.online:3001/pushapi',
            grant_type: 'authorization_code',
        };
        return Call(`https://oauth2.googleapis.com/token`, 'POST', body, true);
    },

    getReport(token, startDate, endDate, domain) {
        const params = {
            startDate,
            endDate,
            currency: 'USD',
            dimension: [ 'COUNTRY_CODE', 'DATE' ],
            metric: [ 'CLICKS', 'EARNINGS', 'PAGE_VIEWS' ],
            filter: `DOMAIN_NAME==${domain}`
        };
        const headers = { Authorization: `Bearer ${token}` };

        return Call(`https://www.googleapis.com/adsense/v1.4/accounts/pub-8091839377276584/reports?${queryString.stringify(params)}`, 'GET', null, true, headers);
    }
};

export default AdSense;


// WEBPACK FOOTER //
// ./src/services/API/components/AdSense.js